import { NgModule } from '@angular/core'
import { MbUserStoreModule } from './store/mb-user-store.module'
import { MbUserAddressAdapter } from './connectors'
import { MbOccUserAddressAdapter } from './adapters'
import { MbUserAccountService } from './services/mb-user-account.service'
import { UserAccountEventListener, UserAccountFacade } from '@spartacus/user/account/root'
import { UserAccountAdapter, UserAccountConnector } from '@spartacus/user/account/core'
import { OccUserAccountAdapter } from '@spartacus/user/account/occ'
import { MbUserAccountEventListener } from './events/mb-user-account-event.listener'

@NgModule({
  imports: [
    MbUserStoreModule,
  ],
  providers: [
    {
      provide: UserAccountAdapter,
      useClass: OccUserAccountAdapter
    },
    UserAccountConnector, //used by MbUserAccountService
    {
      provide: MbUserAddressAdapter,
      useExisting: MbOccUserAddressAdapter
    },
    {
      provide: UserAccountEventListener,
      useExisting: MbUserAccountEventListener
    }
  ]
})
export class UserModule {
}
